import api from './api';

/**
 * Serviço para gerenciamento de condições de pagamento
 */
const paymentConditionsService = {
  // Listar todas as condições
  getAllConditions: async (params = {}) => {
    try {
      const response = await api.get('/payment-conditions', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar condições de pagamento:', error);
      throw error;
    }
  },

  // Buscar condição por ID
  getConditionById: async (id) => {
    try {
      const response = await api.get(`/payment-conditions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar condição:', error);
      throw error;
    }
  },

  // Criar ou atualizar condição
  upsertCondition: async (conditionData) => {
    try {
      const method = conditionData.id ? 'PUT' : 'POST';
      const url = conditionData.id 
        ? `/payment-conditions/${conditionData.id}`
        : '/payment-conditions';
      
      const response = await api[method.toLowerCase()](url, conditionData);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar condição:', error);
      throw error;
    }
  },

  // Deletar condição (desativar)
  deleteCondition: async (id) => {
    try {
      const response = await api.delete(`/payment-conditions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar condição:', error);
      throw error;
    }
  },

  // Calcular valor final com condição de pagamento
  calculateFinalPrice: async (basePrice, paymentConditionId) => {
    try {
      const response = await api.post('/payment-conditions/calculate', {
        base_price: basePrice,
        payment_condition_id: paymentConditionId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular preço final:', error);
      throw error;
    }
  },

  // Buscar condições de pagamento de um projeto
  getProjectPaymentConditions: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/payment-conditions`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar condições de pagamento do projeto:', error);
      throw error;
    }
  }
};

export default paymentConditionsService;
